let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ezsk")).then(() => parcelRequire('6y9Ty'));